import { render, staticRenderFns } from "./BlacklistCRUD.vue?vue&type=template&id=d7fc0a2c&"
import script from "./BlacklistCRUD.vue?vue&type=script&lang=js&"
export * from "./BlacklistCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports